import {FETCH_CLASS,UPDATE_CLASS} from '../actions/ActionTypes';

const initialState = {
	classesValue: []	
 };

export default function (state = initialState, action) {
	switch (action.type) {
		case FETCH_CLASS:
			return {
				...state,
				classesValue:action.data			
            };
		
			case UPDATE_CLASS:
            return {
                ...state,  
				classesValue:state.classesValue.map(
                  (data, i) => data.id === action.data.id ? {  ...data, ...action.data } : data)};

          default:
			return state;
	}
}